import { lazy } from 'react';

import Loadable from 'components/Loadable';

const AnamnesePublica = Loadable(lazy(() => import('pages/public/AnamnesePublica')));

const PublicRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/anamnese',
          element: <AnamnesePublica />
        }
      ]
    }
  ]
};

export default PublicRoutes;
